<!-- Modal -->
<div id="call-visor-modal" [style.display]="callVisorModalFlag ? 'block' : 'none'" class="modal" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-body visor-popup">
        <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
          (click)="closeModal()"><span aria-hidden="true">&times;</span></button>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
              <!-- 1st popup start -->
              @if (!showSuccess && !showFailure) {
                <div class="help-card">
                  <div class="help-header">
                    <h2>Call for Help</h2>
                    <p>
                      Please review your information below to submit your request.
                      A care team representative will contact you shortly.
                    </p>
                  </div>
                  <div class="help-details">
                    <div class="help-row">
                      <span class="label">Full Name</span>
                      <span class="value">{{formateName(callvisorData?.lastName)}}, {{formateName(callvisorData?.firstName)}}</span>
                    </div>
                    <div class="help-row">
                      <span class="label">Date of Birth</span>
                      @if (callvisorData?.dob) {
                        <span class="value">{{(getAppointmentTime(callvisorData?.dob)) || '--'}}</span>
                      }
                    </div>
                    <div class="help-row">
                      <span class="label">Phone</span>
                      <span class="value">{{getPhoneNumber(callvisorData) }}</span>
                    </div>
                    <div class="help-row">
                      <span class="label">Purpose of visit</span>
                      <span class="value" ngbTooltip="{{callvisorData?.episodeOfCareFullName}}">{{callvisorData?.episodeOfCareName || 'N/A'}}</span>
                    </div>
                  </div>
                  <div class="help-note">
                    <label for="callvisorModal_note">Add a note (optional)</label>
                    <textarea id="callvisorModal_note" placeholder="Enter any details you would like the care team to know" [(ngModel)]="patientNotes"></textarea>
                  </div>
                  <div class="help-actions">
                    <button type="button" class="btn cancel-btn" (click)="closeModal()">Cancel</button>
                    <button type="button" class="btn btn-primary" id="exceptional_ok"
                      [disabled]="loadSpinner" (click)="submitModal()">Submit</button>
                  </div>
                </div>
              }
              <!-- 1st popup end -->


              <!-- Second popup start -->
              @if (showSuccess) {
                <div class="help-card">
                  <!-- <i class="fa fa-check-circle"></i> -->
                  <!-- <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg> -->
                  <div class="check_mark">
                    <div class="sa-icon sa-success animate">
                      <span class="sa-line sa-tip animateSuccessTip"></span>
                      <span class="sa-line sa-long animateSuccessLong"></span>
                      <div class="sa-placeholder"></div>
                      <div class="sa-fix"></div>
                    </div>
                  </div>
                  <div class="help-header">
                    <h2> Request Received</h2>
                    <p>
                      {{callVisornotifyText || 'We have received your request and will call you within 30 minutes.'}}
                    </p>
                    <p>
                      <b>If this is an emergency, Please call 911.</b>
                    </p>
                    <p>
                      You can continue to use the App to provide your injury details and health history.
                    </p>
                  </div>
                  <div class="help-actions">
                    <button type="button" class="btn btn-primary" data-dismiss="modal" id="exceptional_ok"(click)="closeModal()">Done</button>
                  </div>
                </div>
              }
              <!-- Second popup end -->

              <!-- Third popup start -->
              @if (showFailure) {
                <div class="help-card">
                  <div class="check_mark">
                    <div class="sa-icon sa-error animate">
                      <span class="sa-line sa-tip animateErrorTip"></span>
                      <span class="sa-line sa-long animateErrorLong"></span>
                      <div class="sa-placeholder"></div>
                      <div class="sa-fix"></div>
                    </div>
                  </div>
                  <div class="help-header">
                    <h2> Request Failed</h2>
                    <p>
                      {{callVisornotifyText || 'There was a problem submitting your request.'}}
                    </p>
                    <p>
                      <b>If this is an emergency, Please call 911.</b>
                    </p>
                  </div>
                  <div class="help-actions">
                    <button type="button" class="btn btn-primary" id="exceptional_ok" (click)="tryAgain()">Try Again</button>
                  </div>
                </div>
              }
              <!-- Third popup end -->
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

<app-load-spinner [loadSpinner]="callVisorModalFlag && loadSpinner"></app-load-spinner>
